import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import {firstNestedSymbolControl, NumberControl} from '../../../models/uiArtefakt';
import {UIDarstellungsart} from '../../../models/uiDarstellungsart';
import {NgForm, NgModel} from '@angular/forms';
import {ValidationService} from '../../../services/validation.service';
import {UiUpdateService} from '../../../services/ui-update.service';
import {ShellConfigService} from '../../../services/shell-config.service';
import {UIAusrichtung} from '../../../models/uiAusrichtung';
import {ISymbol, TranslationService} from '@lv1871/core';
import {EventService} from '../../../services/event.service';

@Component({
    selector: 'lv-zeitraum',
    templateUrl: './zeitraum.component.html',
    styleUrls: ['./zeitraum.component.scss'],
    standalone: false
})
export class ZeitraumComponent implements OnInit, AfterViewInit {
  @ViewChild(NgForm, {static: true})
  private _ngForm;

  @ViewChild('jahresControl', {static: true})
  private _jahresControl: NgModel;

  @ViewChild('monatsControl', {static: true})
  private _monatsControl: NgModel;

  public isDisabled: boolean = false;
  public uiAusrichtung: UIAusrichtung;
  public nestedSymbol: ISymbol;
  public showInfotextCollapsable: boolean = false;
  public model: number = 0;
  public jahr: number;
  public monat: number;

  public jahre: number[] = [];
  public monate: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  public showUntruncatedError: boolean = false;

  private _uiArtefakt: NumberControl;

  constructor(private _validationService: ValidationService,
              private _shellConfigService: ShellConfigService, private _uiUpdateService: UiUpdateService,
              private _translationService: TranslationService, private _eventService: EventService,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  get uiArtefakt(): NumberControl {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(uiArtefakt: NumberControl) {
    this._uiArtefakt = uiArtefakt;
    this.model = uiArtefakt.WertEingabe;
    if (!!this.model) {
      this.monat = this.model % 12;
      this.jahr = Math.trunc(this.model / 12);
    }
    this.isDisabled = this._uiArtefakt.Darstellungsart === UIDarstellungsart.DISABLED;
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  public infotextCollapsableChange(event) {
    this.showInfotextCollapsable = event;
  }

  public ngOnInit(): void {
    this.uiAusrichtung = this._shellConfigService.getParameter().uiAusrichtung;
    this.nestedSymbol = firstNestedSymbolControl(this.uiArtefakt?.UIArtefakt);
    const maximaleJahre = this.uiArtefakt?.WertEingabeMax / 12;
    for (let i = 0; i <= maximaleJahre; i++) {
      this.jahre.push(i);
    }
    this._validationService.registerForm(this.uiArtefakt, this._ngForm);
  }

  onBlur() {
    if(!!this._uiArtefakt.ReferenzIdentifikator){
      this._eventService.refIdentTouchedOrDirty$.next(this._uiArtefakt.ReferenzIdentifikator);
    }
  }

  public getError(): string {
    if (!this._monatsControl.touched && !this._jahresControl.touched) {
      return null;
    }

    if (this.uiArtefakt?.PflichtfeldJN && !this.uiArtefakt?.WertEingabe && this.uiArtefakt?.WertEingabe !== 0) {
      const requiredError = this._translationService.translate('ERRORS.REQUIRED');
      return !!this.uiArtefakt.FehlertextPflichtfeld ? this.uiArtefakt.FehlertextPflichtfeld : requiredError;
    }
    if (this.uiArtefakt?.WertEingabe < this.uiArtefakt?.WertEingabeMin) {
      if (this.uiArtefakt?.WertEingabeMin === 1) {
        return 'Bitte mindestens ' + this.uiArtefakt.WertEingabeMin + ' Monat eingeben';
      } else {
        return 'Bitte mindestens ' + this.uiArtefakt.WertEingabeMin + ' Monate eingeben';
      }
    }
    if (!!this.uiArtefakt?.UIMeldung?.length) {
      return this.uiArtefakt?.UIMeldung[0].Meldungstext;
    }
    this.showUntruncatedError = false;
    return null;
  }

  public onErrorClick() {
    this.showUntruncatedError = !this.showUntruncatedError;
  }

  changeJahre($event: number) {
    this.jahr = $event;
    let monat= this.monat;
    if (!monat) {
      monat = 0;
    }
    this.model = this.jahr * 12 + monat;
    if (this.model > this.uiArtefakt.WertEingabeMax) {
      this.model = this.uiArtefakt.WertEingabeMax;
      this.monat = 0;
    }
    this.uiArtefakt.WertEingabe = this.model;
    this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
  }

  changeMonate($event: number) {
    this.monat = $event;
    let jahr= this.jahr;
    if (!jahr) {
      jahr = 0;
    }
    this.model = jahr * 12 + this.monat;
    this.uiArtefakt.WertEingabe = this.model;
    this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
  }

  getMonatsUnit(monat: number): string {
    if (monat === 1) {
      return 'Monat';
    }
    return 'Monate';
  }

  getJahresUnit(jahr: number): string {
    if (jahr === 1) {
      return 'Jahr';
    }
    return 'Jahre';
  }
}
